import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  communityWrapper: {
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      gap: theme.spacing(0.5),
      padding: theme.spacing(0.5),
      width: 'unset',
    },

    [theme.breakpoints.up('md')]: {
      // minHeight: '96px',
      padding: theme.spacing(1),
      gap: theme.spacing(1),
      display: 'flex',
      cursor: 'pointer',
      borderRadius: '10px',
      '&:hover': {
        backgroundColor: theme.palette.background.default,
      },
    },
  },

  infoWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    flex: 1,
    minWidth: 0,
    height: '100%',

    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },

  infoName: {},

  communityWrapperWithMargin: {},
}));
